var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisclosure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 100,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-surface)",
  stroke: "var(--hop-neutral-border-strong)",
  strokeWidth: 2,
  d: "M8 1h144a7 7 0 0 1 7 7v23H1V8a7 7 0 0 1 7-7Zm0 98h144a7 7 0 0 0 7-7V31H1v61a7 7 0 0 0 7 7Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--hop-neutral-border-strong)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m137.983 19.328 4.656-4.655 4.655 4.655"
})));
export default SvgDisclosure;